import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import MermaidDiagram from "@/components/MermaidDiagram";
import remarkHtmlBreaks from "@/lib/remarkHtmlBreaks";

// Module-level constants so we don't re-allocate them on every render. The
// `components` prop is consumed by ReactMarkdown via shallow-compare in some
// remark plugins, and stable identity here lets downstream React.memo
// optimizations on long chat transcripts actually take effect.
const CODE_BLOCK_STYLE = {
  margin: 0,
  background: "#161616",
  fontSize: "0.85rem",
  padding: "1rem",
  borderRadius: 0,
};

function CodeRenderer({ inline, className, children, ...props }) {
  const match = /language-(\w+)/.exec(className || "");
  const lang = match ? match[1].toLowerCase() : "";
  const raw = String(children).replace(/\n$/, "");

  if (!inline && lang === "mermaid") {
    return <MermaidDiagram code={raw} />;
  }

  if (!inline && (match || String(children).includes("\n"))) {
    return (
      <SyntaxHighlighter
        language={lang || "text"}
        style={vscDarkPlus}
        PreTag="div"
        customStyle={CODE_BLOCK_STYLE}
        {...props}
      >
        {raw}
      </SyntaxHighlighter>
    );
  }
  return <code className={className} {...props}>{children}</code>;
}

const MARKDOWN_COMPONENTS = { code: CodeRenderer };
const MARKDOWN_REMARK_PLUGINS = [remarkGfm, remarkHtmlBreaks];

export default function Markdown({ children }) {
  return (
    <div className="ml-markdown">
      <ReactMarkdown
        remarkPlugins={MARKDOWN_REMARK_PLUGINS}
        components={MARKDOWN_COMPONENTS}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
